import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, FormGroup, Label } from "reactstrap";
import QwikForm from "components/form/QwikForm";
import QwikInput from "components/form/QwikInput";
import QwikSelect from "components/form/QwikSelect";
import { useUpdateJobMutation } from "store/features/jobs/jobManagementApi";
import { toast } from "sonner";

const EditJobModal = ({ isOpen, toggle, job, onJobUpdate }) => {
  const [updateJob, { isLoading }] = useUpdateJobMutation();
  const [formData, setFormData] = useState({});

  // Initialize form data when job data changes
  useEffect(() => {
    if (job) {
      setFormData({
        title: job.title || '',
        position: job.position || '',
        company: job.company || '',
        location: job.location || '',
        duration: job.duration || '',
        date: job.date || '',
        jobcatagory: job.jobcatagory || '',
        salary: job.salary || '',
        aboutpossitiondetails: job.aboutpossitiondetails || '',
        requirementsdetails: job.requirementsdetails || '',
        responsibilites: job.responsibilites || '',
        employeebanifits: job.employeebanifits || '',
        joboffer: job.joboffer || '',
        jobdetails: job.jobdetails || '',
        applyprocess: job.applyprocess || '',
        appicationDuration: job.appicationDuration || '',
        type: job.type || '',
        likes: job.likes || '0',
      });
    }
  }, [job]);

  const handleSubmit = async (data) => {
    try {
      const submitData = {
        title: data.title || formData.title,
        position: data.position || formData.position,
        company: data.company || formData.company,
        location: data.location || formData.location,
        duration: data.duration || formData.duration,
        date: data.date || formData.date,
        jobcatagory: data.jobcatagory || formData.jobcatagory,
        salary: data.salary !== undefined ? data.salary : formData.salary,
        aboutpossitiondetails: data.aboutpossitiondetails || formData.aboutpossitiondetails,
        requirementsdetails: data.requirementsdetails || formData.requirementsdetails,
        responsibilites: data.responsibilites || formData.responsibilites,
        employeebanifits: data.employeebanifits || formData.employeebanifits,
        joboffer: data.joboffer || formData.joboffer,
        jobdetails: data.jobdetails || formData.jobdetails,
        applyprocess: data.applyprocess || formData.applyprocess,
        appicationDuration: data.appicationDuration || formData.appicationDuration,
        type: data.type || formData.type,
        likes: data.likes || formData.likes,
      };

      await updateJob({ id: job.id, formData: submitData }).unwrap();
      toast.success("Job updated successfully");
      onJobUpdate();
      handleModalClose();
    } catch (error) {
      toast.error("Failed to update job");
      console.error('Job update error:', error);
    }
  };

  const handleModalClose = () => {
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleModalClose} size="lg">
      <ModalHeader toggle={handleModalClose}>Edit Job - {job?.title}</ModalHeader>
      <QwikForm onSubmit={handleSubmit} defaultValues={job}>
        <ModalBody>
          <Row>
            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="title"
                  label="Job Title"
                  placeholder="Enter job title"
                  type="text"
                  className="form-control"
                  required
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <QwikSelect
                  name="position"
                  label="Position Type"
                  options={[
                    { value: "Full Time Permanent", label: "Full Time Permanent" },
                    { value: "Internship", label: "Internship" },
                    { value: "Contract", label: "Contract" },
                    { value: "Part-time", label: "Part-time" },
                  ]}
                  required
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="company"
                  label="Company"
                  placeholder="Enter company name"
                  type="text"
                  className="form-control"
                  required
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="location"
                  label="Location"
                  placeholder="Enter job location"
                  type="text"
                  className="form-control"
                  required
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="duration"
                  label="Duration"
                  placeholder="e.g., 3 Months, Permanent"
                  type="text"
                  className="form-control"
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="date"
                  label="Posted Date"
                  type="date"
                  className="form-control"
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <QwikSelect
                  name="jobcatagory"
                  label="Job Category"
                  options={[
                    { value: "Remote", label: "Remote" },
                    { value: "Onsite", label: "On-site" },
                    { value: "Hybrid", label: "Hybrid" },
                    { value: "Contract", label: "Contract" },
                    { value: "Internship", label: "Internship" },
                  ]}
                  required
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="salary"
                  label="Salary / Compensation"
                  placeholder="e.g., Negotiable or 25,000 - 35,000 BDT"
                  type="text"
                  className="form-control"
                />
              </div>
            </Col>
            {/* <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="likes"
                  label="Likes Count"
                  placeholder="Enter likes count"
                  type="number"
                  className="form-control"
                />
              </div>
            </Col> */}

            {/* Text Area Fields */}
            <Col lg={12}>
              <div className="mb-3">
                <QwikInput
                  name="aboutpossitiondetails"
                  label="About Position Details"
                  placeholder="Enter details about the position..."
                  type="textarea"
                  className="form-control"
                  rows="3"
                />
              </div>
            </Col>

            <Col lg={12}>
              <div className="mb-3">
                <QwikInput
                  name="requirementsdetails"
                  label="Requirements Details"
                  placeholder="Enter job requirements..."
                  type="textarea"
                  className="form-control"
                  rows="3"
                />
              </div>
            </Col>

            <Col lg={12}>
              <div className="mb-3">
                <QwikInput
                  name="responsibilites"
                  label="Responsibilities"
                  placeholder="Enter job responsibilities..."
                  type="textarea"
                  className="form-control"
                  rows="3"
                />
              </div>
            </Col>

            <Col lg={12}>
              <div className="mb-3">
                <QwikInput
                  name="employeebanifits"
                  label="Employee Benefits"
                  placeholder="Enter employee benefits..."
                  type="textarea"
                  className="form-control"
                  rows="3"
                />
              </div>
            </Col>

            <Col lg={12}>
              <div className="mb-3">
                <QwikInput
                  name="joboffer"
                  label="Job Offer Details"
                  placeholder="Enter job offer details..."
                  type="textarea"
                  className="form-control"
                  rows="3"
                />
              </div>
            </Col>

            <Col lg={12}>
              <div className="mb-3">
                <QwikInput
                  name="jobdetails"
                  label="Job Details"
                  placeholder="Enter additional job details..."
                  type="textarea"
                  className="form-control"
                  rows="3"
                />
              </div>
            </Col>

            {/* <Col lg={12}>
              <div className="mb-3">
                <QwikInput
                  name="applyprocess"
                  label="Application Process"
                  placeholder="Enter application process..."
                  type="textarea"
                  className="form-control"
                  rows="3"
                />
              </div>
            </Col> */}

            {/* <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="appicationDuration"
                  label="Application Duration"
                  placeholder="e.g., 30 days"
                  type="text"
                  className="form-control"
                />
              </div>
            </Col> */}

            {/* <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="type"
                  label="Job Type"
                  placeholder="e.g., Technical, Marketing"
                  type="text"
                  className="form-control"
                />
              </div>
            </Col> */}
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="light" onClick={handleModalClose}>
            Cancel
          </Button>
          <Button type="submit" color="primary" disabled={isLoading}>
            {isLoading ? "Updating..." : "Update Job"}
          </Button>
        </ModalFooter>
      </QwikForm>
    </Modal>
  );
};

export default EditJobModal;